import apiClient from './client';
import { Account, CreateAccountRequest } from '../types';

export const accountsApi = {
  /**
   * List all accounts for a client
   */
  listAccounts: async (clientId: string): Promise<Account[]> => {
    const response = await apiClient.get<Account[]>(`/clients/${clientId}/accounts`);
    return response.data;
  },

  /**
   * Create a new account for a client
   */
  createAccount: async (
    clientId: string,
    data: CreateAccountRequest
  ): Promise<Account> => {
    const response = await apiClient.post<Account>(
      `/clients/${clientId}/accounts`,
      data
    );
    return response.data;
  },
};
